function formatHoursValue(value) {
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, '');
}

function formatBool(value, t) {
  return value ? t('personnelHoursHistory.yes') : t('personnelHoursHistory.no');
}

export function formatAuditChangeLines(log, t) {
  const changes = log.changes || {};
  const lines = [];

  if (log.action === 'CREATE') {
    if (changes.hours?.to != null) {
      lines.push(t('personnelHoursHistory.createdHours', { hours: formatHoursValue(changes.hours.to) }));
    }
    if (changes.startTime?.to || changes.endTime?.to) {
      lines.push(t('personnelHoursHistory.timeRangeSet', {
        defaultValue: 'Time {{from}}–{{to}}',
        from: changes.startTime?.to || '—',
        to: changes.endTime?.to || '—',
      }));
    }
    if (changes.usedLunch?.to != null) {
      lines.push(t('personnelHoursHistory.lunchSet', {
        defaultValue: 'Lunch: {{value}}',
        value: formatBool(changes.usedLunch.to, t),
      }));
    }
    if (changes.workhoursReducedForLunch?.to != null && Number(changes.workhoursReducedForLunch.to) > 0) {
      lines.push(t('personnelHoursHistory.lunchReductionSet', {
        defaultValue: 'Lunch reduction: {{hours}} h',
        hours: formatHoursValue(changes.workhoursReducedForLunch.to),
      }));
    }
    if (changes.wasRaining?.to != null) {
      lines.push(t('personnelHoursHistory.rainDaySet', { value: formatBool(changes.wasRaining.to, t) }));
    }
    if (changes.notes?.to) {
      lines.push(t('personnelHoursHistory.notesSet', { defaultValue: 'Note added' }));
    }
    if (lines.length === 0) {
      lines.push(t('personnelHoursHistory.created'));
    }
    return lines;
  }

  if (log.action === 'DELETE') {
    if (changes.hours?.from != null) {
      lines.push(t('personnelHoursHistory.deletedWasHours', { hours: formatHoursValue(changes.hours.from) }));
    } else {
      lines.push(t('personnelHoursHistory.deleted'));
    }
    return lines;
  }

  if (changes.hours) {
    lines.push(t('personnelHoursHistory.hoursChanged', {
      from: formatHoursValue(changes.hours.from),
      to: formatHoursValue(changes.hours.to),
    }));
  }
  if (changes.startTime || changes.endTime) {
    lines.push(t('personnelHoursHistory.timeRangeChanged', {
      defaultValue: 'Time {{fromStart}}–{{fromEnd}} → {{toStart}}–{{toEnd}}',
      fromStart: changes.startTime?.from ?? '—',
      fromEnd: changes.endTime?.from ?? '—',
      toStart: changes.startTime?.to ?? '—',
      toEnd: changes.endTime?.to ?? '—',
    }));
  }
  if (changes.usedLunch) {
    lines.push(t('personnelHoursHistory.lunchChanged', {
      defaultValue: 'Lunch {{from}} → {{to}}',
      from: formatBool(changes.usedLunch.from, t),
      to: formatBool(changes.usedLunch.to, t),
    }));
  }
  if (changes.workhoursReducedForLunch) {
    lines.push(t('personnelHoursHistory.lunchReductionChanged', {
      defaultValue: 'Lunch reduction {{from}} → {{to}} h',
      from: formatHoursValue(changes.workhoursReducedForLunch.from),
      to: formatHoursValue(changes.workhoursReducedForLunch.to),
    }));
  }
  if (changes.wasRaining) {
    lines.push(t('personnelHoursHistory.rainDayChanged', {
      from: formatBool(changes.wasRaining.from, t),
      to: formatBool(changes.wasRaining.to, t),
    }));
  }
  if (changes.notes) {
    lines.push(t('personnelHoursHistory.notesChanged'));
  }

  if (lines.length === 0) {
    lines.push(t('personnelHoursHistory.updated'));
  }

  return lines;
}

export function formatAuditTimestamp(date, formatDateEuropean) {
  if (!date) return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const datePart = formatDateEuropean(d);
  const timePart = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  return `${datePart} ${timePart}`;
}
